import React from 'react';

const StoresHeader = () => {
    return (
        <h1>Stores</h1>
    );
};

export default StoresHeader;
